import * as React from 'react';
import { Layout } from '../Layout';
import { VerticalSlider } from '../VerticalSlider';
import * as styles from './Mortgage.css';

interface IMortgageProps {
  title: React.ReactNode;
  banks: React.ReactNode;
  getMortgage: React.ReactNode;
}

export function Mortgage({ title, banks }: IMortgageProps) {
  return (
    <section className={styles['mortgage']}>
      <Layout>
        <div className={styles['mortgage__title']}>{title}</div>

        <div className={styles['mortgage__banks']}>
          <VerticalSlider>{React.Children.map(banks, bank => bank)}</VerticalSlider>
        </div>
      </Layout>
    </section>
  );
}
